export function isChina() {
  const showChinaInLocal = true && process.env.NEXT_PUBLIC_SERVER === "Local";

  return process.env.NEXT_PUBLIC_SERVER === "China" || showChinaInLocal;
}
